export default [
  {
    path: '/library/add',
    name: 'library-add',
    component: () => import('@/modules/library/add/addBook'),

  },
  {
    path: '/library/list',
    name: 'library-list',
    component: () => import('@/modules/library/list/listBooks'),
  },

]
